import { render, staticRenderFns } from "./InvestigatorList.vue?vue&type=template&id=ec1fb986&scoped=true"
import script from "./InvestigatorList.vue?vue&type=script&lang=js"
export * from "./InvestigatorList.vue?vue&type=script&lang=js"
import style0 from "./InvestigatorList.vue?vue&type=style&index=0&id=ec1fb986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1fb986",
  null
  
)

export default component.exports